<!-- 产品中心-产品功能 -->
<template>
	<div class="ProductFeatures-warp">
		<div
			class="feature-card"
			v-for="(item, index) in capabilities"
			:key="index"
		>
			<div class="feature-card-icon">
				<img :src="item.capacityImg" alt="产品功能图标" />
			</div>
			<div class="feature-card-name">{{ item.capacityName }}</div>
			<div class="feature-card-desc">
				{{ item.capacityIntroduction }}
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'ProductFeatures',
	data() {
		return {}
	},
	props: {
		overview: String,
		productName: String,
		outlined: Array,
		capabilities: Array,
	},
}
</script>
<style lang="scss" scoped>
.ProductFeatures-warp {
	width: 100%;
	margin: 0 auto;
	display: grid;
	/* 1920：卡片 390×220，三列 + gap 20 */
	grid-template-columns: repeat(3, 390px);
	justify-content: center;
	gap: 20px;
	box-sizing: border-box;
	background-color: #ffffff;
}

.feature-card {
	width: 390px;
	height: 220px;
	padding: 28px 26px;
	box-sizing: border-box;
	/* 始终用 background-image，避免 color ↔ gradient 无法插值导致移出闪白 */
	background-color: #f5f9ff;
	background-image: linear-gradient(180deg, #f5f9ff 0%, #f5f9ff 100%);
	border-radius: 20px;
	border: 1px solid #f2f5ff;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	transition: background-image 0.3s ease, box-shadow 0.3s ease,
		transform 0.3s ease, border-color 0.3s ease;

	&-icon {
		width: 48px;
		height: 48px;
		border-radius: 50%;
		overflow: hidden;
		flex-shrink: 0;

		img {
			width: 100%;
			height: 100%;
			object-fit: contain;
			display: block;
		}
	}

	&-name {
		margin-top: 20px;
		font-size: 20px;
		font-family: 'PingFang SC', 'Source Han Sans SC';
		font-weight: 500;
		color: #333333;
		line-height: 30px;
		transition: color 0.3s ease;
	}

	&-desc {
		margin-top: 12px;
		font-size: 16px;
		font-family: 'PingFang SC', 'Source Han Sans SC';
		font-weight: 400;
		color: #666666;
		line-height: 24px;
	}

	&:hover {
		background-image: linear-gradient(180deg, #f5f9ff 0%, #f8fbff 100%);
		border-color: #f2f5ff;
		box-shadow: 0 6px 20px 0 rgba(66, 135, 255, 0.1);
		transform: translateY(-8px);

		.feature-card-name {
			color: #2185ff;
		}
	}
}

@media screen and (max-width: 768px) {
	.ProductFeatures-warp {
		grid-template-columns: repeat(3, minmax(0, 1fr));
		gap: 8px;
	}

	.feature-card {
		width: 100%;
		height: auto;
		min-height: 96px;
		padding: 12px 8px;
		border-radius: 8px;
		align-items: center;
		text-align: center;
		background-color: #f5f9ff;
		background-image: linear-gradient(180deg, #f5f9ff 0%, #f5f9ff 100%);
		border: 1px solid #f2f5ff;

		&-icon {
			width: 40px;
			height: 40px;
		}

		&-name {
			margin-top: 8px;
			font-size: 10px;
			font-weight: 500;
			line-height: 16px;
			color: #525c6a;
		}

		/* 手机端仅保留图标与功能名 */
		&-desc {
			display: none;
		}

		&:hover {
			background-image: linear-gradient(180deg, #f5f9ff 0%, #f8fbff 100%);
			border-color: #f2f5ff;
			box-shadow: 0 6px 20px 0 rgba(66, 135, 255, 0.1);
			transform: translateY(-4px);

			.feature-card-name {
				color: #2185ff;
			}
		}
	}
}
</style>
